import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Button,
} from "@mui/material";

interface Dimension {
  analyze_question: string;
  guidance?: string;
  id?: string;
}

interface AddDimensionDialogProps {
  open: boolean;
  onClose: () => void;
  onAdd: (dimension: Dimension) => void;
  newDimension: Dimension;
  onDimensionChange: (dimension: Dimension) => void;
}

const AddDimensionDialog: React.FC<AddDimensionDialogProps> = ({
  open,
  onClose,
  onAdd,
  newDimension,
  onDimensionChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Add New Dimension</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Question"
            multiline
            rows={2}
            value={newDimension.analyze_question}
            onChange={(e) =>
              onDimensionChange({
                ...newDimension,
                analyze_question: e.target.value,
              })
            }
            sx={{ mb: 2 }}
            helperText="What aspect should be analyzed for this dimension? (e.g. 'Past experience in Python')"
          />
          <TextField
            fullWidth
            label="Guidance"
            multiline
            rows={2}
            value={newDimension.guidance || ""}
            onChange={(e) =>
              onDimensionChange({ ...newDimension, guidance: e.target.value })
            }
            sx={{ mb: 2 }}
            helperText="Guidance for evaluating this dimension (e.g. 'Check if the user is familiar with asyncio')"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => onAdd(newDimension)}
          variant="contained"
          disabled={!newDimension.analyze_question}
        >
          Add Dimension
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDimensionDialog;
